import React from 'react';

function ProjectNameCell({ project }) {
  return (
    <div className="dashboard-project-name">
      <span>{project.name}</span>
      {project.variantLabel && (
        <span className="dashboard-project-variant-badge">
          {project.variantLabel}
        </span>
      )}
    </div>
  );
}

export default function ProjectsView({ projects, onSelectProject }) {
  return (
    <>
      <div className="dashboard-section-header">
        <div>
          <p className="dashboard-mini-label">PROJECTS</p>
          <h2 className="dashboard-section-title">Project Management</h2>
          <p className="dashboard-section-description">
            Monitor live projects, review status, and track investment or development progress.
          </p>
        </div>
      </div>

      <div className="dashboard-table-wrap">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Project</th>
              <th>Category</th>
              <th>Status</th>
              <th>Owner</th>
              <th>Timeline</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project) => (
              <tr key={project.id}>
                <td><ProjectNameCell project={project} /></td>
                <td>{project.category}</td>
                <td>
                  <span className={`status-badge ${project.statusClass}`}>
                    {project.status}
                  </span>
                </td>
                <td>{project.owner}</td>
                <td>{project.timeline}</td>
                <td>
                    <button
                    type="button"
                    className="dashboard-table-action-btn"
                    onClick={() => onSelectProject(project.id)}
                    >
                    <span className="dashboard-table-action-text">Open Project</span>
                    <span className="dashboard-table-action-icon">↗</span>
                    </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
